export default __webpack_public_path__ + "img/ic-airNz.6bf0db77.png";